import { render, staticRenderFns } from "./AIAnalysisReport.vue?vue&type=template&id=4452e7af"
import script from "./AIAnalysisReport.vue?vue&type=script&lang=js"
export * from "./AIAnalysisReport.vue?vue&type=script&lang=js"
import style0 from "./AIAnalysisReport.vue?vue&type=style&index=0&id=4452e7af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports